/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxSelectBoxModule, DxButtonModule,DxTooltipModule  } from 'devextreme-angular';
import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { SysqueTextButtonModule } from '../../../../../../../shared/ui/src/lib/components/sysque-text-button';
import { ProjectDataComponent } from './project-data-component';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [
  { path: 'dialog/project-data-dialog', component: ProjectDataComponent },
];

@NgModule({
  declarations: [ProjectDataComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    DxSelectBoxModule,
    DxButtonModule,
    SysqueFrameModule,
    SysqueTextButtonModule,
    AlertModule,
    DxTooltipModule
  ],
  exports: [ProjectDataComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProjectDataModule {}
